import {HOST} from "common-import/constants";
import numeral from 'numeral';
import moment from 'moment';
import * as XLSX from 'xlsx';
const GOOGLE_API_KEY = "AIzaSyD-JPRA2FTbE6dLSlTgj55K9WyKYq417PI";

const v = require('voca');

class VarHelper {
  detectType = variable => {
    switch(typeof variable) {
      case "number": return "number";
      case "string": return "string";
      case "undefined": return "undefined";
      case "boolean": return "boolean";
      case "function": return "function";
      case "object":
        if(variable.constructor === Array) return "array";
        if(variable.constructor === Error) return "error";
        if(variable.constructor === Promise) return "promise";
      break;
      default: return "object";
    }
  };

  isArr = (variable) => this.detectType(variable) === 'array';

  filterEmptyObjProp = obj => {
    let newObj = {};
    for (let prop in obj) {
      let value = obj[prop];
      if(value !== "" && value !== null && value !== undefined) newObj[prop] = value;
    }
    return newObj;
  };

  img = url => {
    if (typeof url !== 'string') return url;
    if (url.includes('http')) return url;
    return HOST + url;
  };

  groupInTwoArr = (arr) => {
    let newArr = [];
    let tempArr = [];
    for (let i = 0; i< arr.length; i++) {
      if (tempArr.length === 2) {
        tempArr.length = 0;
        tempArr.push(arr[i]);
        if (i === arr.length - 1) newArr.push(tempArr.slice());
      } else if (tempArr.length === 1) {
        tempArr.push(arr[i]);
        newArr.push(tempArr.slice());
      } else if (tempArr.length === 0) {
        tempArr.push(arr[i]);
        if (i === arr.length - 1) newArr.push(tempArr.slice());
      }
    }

    return newArr;
  };

  moneyString = number => {
    if (number === undefined) return undefined;
    return numeral(number).format('0,0');
  };

  cloneDeep = (item) => {
    const self = this;
    if (!item) { return item; } // null, undefined values check

    let types = [ Number, String, Boolean ],
      result;

    // normalizing primitives if someone did new String('aaa'), or new Number('444');
    types.forEach(function(type) {
      if (item instanceof type) {
        result = type( item );
      }
    });

    if (typeof result === "undefined") {
      if (Object.prototype.toString.call( item ) === "[object Array]") {
        result = [];
        item.forEach(function(child, index, array) {
          result[index] = self.cloneDeep( child );
        });
      } else if (typeof item === "object") {
        // testing that this is DOM
        if (item.nodeType && typeof item.cloneNode === "function") {
          result = item.cloneNode( true );
        } else if (!item.prototype) { // check that this is a literal
          if (item instanceof Date) {
            result = new Date(item);
          } else {
            // it is an object literal
            result = {};
            for (let i in item) {
              result[i] = self.cloneDeep( item[i] );
            }
          }
        } else {
          // depending what you would like here,
          // just keep the reference, or create new object
          if (false && item.constructor) {
            // would not advice to do that, reason? Read below
            result = new item.constructor();
          } else {
            result = item;
          }
        }
      } else {
        result = item;
      }
    }

    return result;
  };

  numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  textMoney = num => {
    const typeNum = typeof num;
    if (typeNum === 'string') return num.replace(/\,000\,000\,000\,000/g, ' nghìn tỷ').replace(/\,000\,000\,000/g, ' tỷ').replace(/\,000\,000/g, ' triệu');
    if (typeNum === 'number') return this.numberWithCommas(num).replace(/\,000\,000\,000\,000/g, ' nghìn tỷ').replace(/\,000\,000\,000/g, ' tỷ').replace(/\,000\,000/g, ' triệu');
    if (typeNum === 'number') return String(num).replace(/000000000000/g, ' nghìn tỷ').replace(/000000000/g, ' tỷ').replace(/000000/g, ' triệu');
    return '';
  };

  getNumber = (value) => {
    return Number(value.toString().split(",").join("")) || 0;
  };

  valueBecameKey = obj => {
    let newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key];
      if (typeof obj[key] === 'string') {
        newObj[obj[key]] = obj[key];
      }
    }
    return newObj;
  };

  copyObjectWithKey = (listKey, obj) => {
    let newObj = {};
    for (let i = 0; i < listKey.length; i++) {
      const key = listKey[i];
      if (obj.hasOwnProperty(key)) {
        newObj[key] = obj[key];
      } else {
        newObj[key] = null;
      }
    }
    return newObj;
  };

  formatValueByType = (obj, needFormat) => {
    let copy = {};
    let format = {
      typeArray: [],
      typeBoolean: [],
      typeDate: [],
      typeNumber: [],
      typeObject: [],
      typeString: [],
    };
    format = Object.assign({}, format, needFormat);
    Object.entries(obj).map(([key, value]) => {
      if (value == null || value === "") {
        // if (format["typeArray"].includes(key)) {
        //   copy[key] = [];
        // }
        // if (format["typeBoolean"].includes(key)) {
        //   copy[key] = false;
        // }
        // if (format["typeDate"].includes(key)) {
        //   copy[key] = Date.now();
        // }
        // if (format["typeNumber"].includes(key)) {
        //   copy[key] = 0;
        // }
        // if (format["typeObject"].includes(key)) {
        //   copy[key] = {};
        // }
        // if (format["typeString"].includes(key)) {
        //   copy[key] = 'null';
        // }
      } else {
        if (format["typeBoolean"].includes(key)) {
          copy[key] = ['true', true, 'yes', 1, '1'].includes(value);
        } else if (format["typeNumber"].includes(key)) {
          copy[key] = Number(value);
        } else if (format["typeString"].includes(key)) {
          copy[key] = value === "" ? "null" : value.toString();
        } else if (format["typeDate"].includes(key)) {
          copy[key] = new Date(value);
        } else if (format["typeArray"].includes(key)) {
          copy[key] = typeof value === "string" ? value.split(",") : value;
        } else {
          copy[key] = value;
        }
      }
    });
    return copy;
  };

  readMoreString = (str, readMore, length) => {
    let desc;
    str = !!str ? str : '';
    if (str.length > length) {
      if (!readMore) {
        desc = str.slice(0, length) + '... ';
      } else {
        desc = str + ' ';
      }
    } else {
      desc = str;
    }
    return desc;
  };

  /**
   * Read xlsx file
   * Document: https://github.com/SheetJS/js-xlsx/tree/master/demos/react
   * Reference: https://www.facebook.com/groups/reactvietnam/permalink/2064235910497759/
   * https://stackoverflow.com/questions/46909260/reading-excel-file-in-reactjs
   *
   * @param e // {Object}
   * @param callback {function}
   * @param sheet {Array} or {Number} or {String}
   */
  readXLSX = (e, callback, sheet = 0) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });

      /**
       * Need to get data multiple sheet name
       */
      if (Array.isArray(sheet)) {
        let resultCallback = {};
        for (let i = 0; i < sheet.length; i++) {
          const s = workbook.Sheets[sheet[i]];
          resultCallback[sheet[i]] = XLSX.utils.sheet_to_json(s, {header: 1});
        }
        callback(resultCallback);
        return null;
      }

      /*
      * Just need to get data one sheet
      * */
      let sheetName = sheet;
      // have no specific sheet name, get default
      if (!sheet) sheetName = workbook.SheetNames[sheet];

      const sheetData = workbook.Sheets[sheetName];
      callback(XLSX.utils.sheet_to_json(sheetData, {header: 1}));
    };
    reader.readAsBinaryString(e.target.files[0]);
  };

  formatDataXLSX = (data) => {
    let newData = [];
    const dataFilter = data.filter((item, index) => item.length && index >= 4);
    const objProps = data[2];
    for (let i = 0; i < dataFilter.length; i++) {
      let obj = {};
      dataFilter[i].map((item, index) => {
        obj[objProps[index]] = item;
      });
      newData = [...newData, obj];
    }
    return newData;
  };

  getRanking = (score) => {
    const rankingList = ["E3", "E2", "E1", "D3", "D2", "D1", "C3", "C2", "C1", "B3", "B2", "B1", "A3", "A2", "A1"];
    return rankingList.find((item, index) => Math.round(score*rankingList.length/35) === (index+1));
  };

  getScoreByPerform = (perform) => {
    perform = Number(perform);
    if (perform < 50) {
      return 1;
    }
    if (50 <= perform && perform <= 59) {
      return 2;
    }
    if (60 <= perform && perform <= 74) {
      return 3;
    }
    if (75 <= perform && perform <= 89) {
      return 4;
    }
    return 5;
  };

  youtubeId = (url) => {
    if (url == undefined) return false;
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    if (match && match[7].length == 11) {
      return match[7];
    } else if (url.includes('youtube.com') && !url.includes('?v')) {
      // https://www.youtube.com/e6XdhaleZ-Q
      let parts = url.split("/");
      return parts[parts.length - 1];
    } else {
      return false;
    }
  };

  toEmbedYoutube = url => {
    let id = this.youtubeId(url);
    if (id === false) return false;
    return `https://www.youtube.com/embed/${id}`;
  };

  getLatLngFromAddress = async address => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&language=vi&key=${GOOGLE_API_KEY}`;
    let res = await fetch(url);
    let json = await res.json();
    let result = json.result || json.results;
    if (result.length === 0) return { lat: undefined, lon: undefined };
    return {
      lat: result[0].geometry.location.lat,
      lon: result[0].geometry.location.lng,
    }
  };

  /*
   * getSpecificMinMax
   * @param value // String
   * @param minFieldName // String
   * @param maxFieldName // String
   * ===================================
   * // for budget, lanArea, constructionArea
  * */
  getSpecificMinMax = (value, minFieldName = 'minBudget', maxFieldName = 'maxBudget') => {
    if (!!value) {
      let obj = {};
      if (value.includes("Less than") || value.includes("Nhỏ hơn")) {
        obj[minFieldName] = 0;
        console.log(value.replace("Less than ", "").replace("Nhỏ hơn ", "").replace(/,/g, ""));
        obj[maxFieldName] = +value.replace("Less than ", "").replace("Nhỏ hơn ", "").replace(/,/g, "");
        return obj;
      } else if (value.includes("Greater than") || value.includes("Lớn hơn")) {
        obj[minFieldName] = 1000000000000;
        obj[maxFieldName] = 1000000000000;
        return obj;
      } else if (value.includes("-")) {
        let [min, max] = value.replace(/,/g, "").split("-");
        obj[minFieldName] = +min.trim();
        obj[maxFieldName] = +max.trim();
        return obj;
      } else if (!isNaN(value)) {
        obj[minFieldName] = 0;
        obj[maxFieldName] = value;
        return obj;
      } else {
        return false;
      }
    }
  };

  getNewArrayCompared = (shortArray, longArray, propToCompare) => {
    return longArray.map((lItem) => {
      const item = shortArray.find(sItem => sItem[propToCompare] === lItem[propToCompare]);
      if (!!item) return item;
      return lItem;
    });
  };

  cssBgImageText = (arrayUrl) => {
    const oneUrl = url => `url("${url}") center center /cover no-repeat`;
    let result = '';
    arrayUrl.forEach((url, i) => {
      result += oneUrl(url);
      if (i !== arrayUrl.length -1 ) result += ', ';
    });
    return result;
  };

  bodauTiengViet = str => {
    if (str == undefined) return '';
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ|ệ|ề/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ|ự/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    // str = str.replace(/ /g, "_");
    return str;
  }

  urlSlug = string => {
    return v.kebabCase(this.bodauTiengViet(string));
  }
}

export default new VarHelper();



// WEBPACK FOOTER //
// ./src/utils/VarHelper.js